/**
 * Videos
 */

const $ = window.jQuery;

// Play button event handler
$('html').on('click', '[data-video-modal-open]', (event) => {
  event.preventDefault();

  const self = $(event.currentTarget);
  const videoModal = self.data('video-modal-open');
  const videoPlayerID = self.data('video-modal-player-id');
  const videoFile = self.data('video-modal-file');
  const videoImg = self.data('thumbnail');
  const $container = $('#' + videoPlayerID);

  // Insert HTML5 video into the container
  $container.html(`
    <video
      controls
      autoplay
      width="100%"
      poster="${videoImg}"
    >
      <source src="${videoFile}" type="video/mp4">
      Your browser does not support HTML5 video.
    </video>
  `);

  $('.video-modal').removeClass('is-visible');
  $(videoModal).addClass('is-visible');
  $('html').addClass('video-modal-visible');
});

// Close button event handler
$('html').on('click', '[data-video-modal-close]', (event) => {
  event.preventDefault();

  const self = $(event.currentTarget);
  const videoModal = self.data('video-modal-close');
  const videoPlayerID = self.data('video-modal-player-id');
  const $container = $('#' + videoPlayerID);

  // Pause and remove the HTML5 video
  const videoEl = $container.find('video').get(0);
  if (videoEl) {
    videoEl.pause();
  }
  $container.empty();

  $(videoModal).removeClass('is-visible');
  $('html').removeClass('video-modal-visible');
});
